import * as types from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { SEND_SELF_SERVICE_SUCCESS } from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/selfServices/types').Mobility} */
export const initialState = null;

/**
 * @param {import('modules/selfServices/types').Mobility} _
 * @param {import('modules/interventions/types/actions').OpenMobilityModalReadyAction} action
 * @returns {import('modules/selfServices/types').Mobility}
 */
const onOpenMobility = (_, { payload }) => payload;

/** @returns {import('modules/selfServices/types').Mobility} */
const reset = (state, { meta }) => (meta?.action === 'resend' ? state : initialState);

export default createReducer(initialState, {
  [LOCATION_CHANGE]: reset,
  [types.CLOSE_MOBILITY_MODAL]: reset,
  [types.OPEN_MOBILITY_MODAL_READY]: onOpenMobility,
  [types.CLOSE_RESEND_MODAL]: reset,
  [SEND_SELF_SERVICE_SUCCESS]: reset
});
